import React from "react";
import ButtonComp from "../buttons/buttonComp/buttonComp";

type IProps = {
    backgroundColor?: string;
    textColor?: boolean;
}

const ReadTheStoriesButton = (props: IProps) => {
    const handleClickScroll = () => {
        const element = document.getElementById('view-position');
        element?.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
    }
    return (
        <ButtonComp fullWidth={true} backgroundColor={props.backgroundColor} visible={false} uppercase={true}
                    textColor={props.textColor} onClick={handleClickScroll}>
            <React.Fragment>
                Hikayeleri oku
            </React.Fragment>
        </ButtonComp>
    );
}

export default ReadTheStoriesButton;
